import { getCurrentInstance, computed } from '@vue/composition-api'

export default function useSummaryDownload (STORE_KEY = '$_dashboard') {
    const vm = getCurrentInstance().proxy
    const store = vm.$store

    const dashboardEditMode = computed(() => store.getters['appConfig/dashboardEditMode'])

    const hasInvoiceStatus = computed(() => store.getters[`${STORE_KEY}/hasInvoiceStatus`])
    const hasInvoice = computed(() => store.getters[`${STORE_KEY}/hasInvoice`])
    const getAvailableInvoice = params => [hasInvoiceStatus, hasInvoice, params && !dashboardEditMode.value ? store.dispatch(`${STORE_KEY}/getAvailableInvoice`, params) : null]

    const downloadSimpleStatus = computed(() => store.getters[`${STORE_KEY}/downloadSimpleStatus`])
    const downloadSimple = computed(() => store.getters[`${STORE_KEY}/downloadSimple`])
    const downloadSimpleExcel = params => [downloadSimpleStatus, downloadSimple, params && !dashboardEditMode.value ? store.dispatch(`${STORE_KEY}/downloadSimpleExcel`, params) : null]

    const downloadDetailStatus = computed(() => store.getters[`${STORE_KEY}/downloadDetailStatus`])
    const downloadDetail = computed(() => store.getters[`${STORE_KEY}/downloadDetail`])
    const downloadDetailCSV = params => [downloadDetailStatus, downloadDetail, params && !dashboardEditMode.value ? store.dispatch(`${STORE_KEY}/downloadDetailCSV`, params) : null]

    const downloadInvoice = computed(() => store.getters[`${STORE_KEY}/downloadInvoice`])
    const downloadInvoiceStatus = computed(() => store.getters[`${STORE_KEY}/downloadInvoiceStatus`])
    const downloadInvoicePDF = params => [downloadInvoiceStatus, downloadInvoice, params && !dashboardEditMode.value ? store.dispatch(`${STORE_KEY}/downloadInvoicePDF`, params) : null]

    return {
        getAvailableInvoice,
        downloadSimpleExcel,
        downloadDetailCSV,
        downloadInvoicePDF
    }
}
